import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { AuthProvider } from './contexts/AuthContext'
import { EntitlementProvider } from './contexts/EntitlementContext'
import { ProjectProvider } from './contexts/ProjectContext'
import { SubscriptionProvider } from './contexts/SubscriptionContext'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { Header } from './components/layout/Header'
import { Footer } from './components/layout/Footer'
import { HomePage } from './pages/HomePage'
import { ServicesPage } from './pages/ServicesPage'
import { ToolsPage } from './pages/ToolsPage'
import { ContactPage } from './pages/ContactPage'
import { ResourcesPage } from './pages/ResourcesPage'
import { QuotePage } from './pages/QuotePage'
import { LoginPage } from './pages/LoginPage'
import { RegisterPage } from './pages/RegisterPage'
import { DesignTemplatesPage } from './pages/DesignTemplatesPage'
import { CodeReferencesPage } from './pages/CodeReferencesPage'
import { CustomCalculationsPage } from './pages/CustomCalculationsPage'
import { ProjectsPage } from './pages/ProjectsPage'
import { ProjectDetailPage } from './pages/ProjectDetailPage'
import { LoopLoadCalculatorPage } from './pages/LoopLoadCalculatorPage'
import BatteryCalculatorPage from './pages/BatteryCalculatorPage'
import { DeviceDatabasePage } from './pages/DeviceDatabasePage'
import { PricingPage } from './pages/PricingPage'
import { CheckoutPage } from './pages/CheckoutPage'
import { CheckoutConfirmationPage } from './pages/CheckoutConfirmationPage'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import VerifyEmail from './pages/VerifyEmail'
import ResendVerification from './pages/ResendVerification'
import EmailPreferences from './pages/EmailPreferences'
import ContactSales from './pages/ContactSales'
import SubscriptionPlans from './pages/SubscriptionPlans'
import { NotFoundPage } from './pages/NotFoundPage'

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <EntitlementProvider>
          <SubscriptionProvider>
            <ProjectProvider>
              <Router>
          <div className="bg-slate-50 text-slate-800 min-h-screen">
            <Header />
            <main>
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<HomePage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/quote" element={<QuotePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/checkout/confirmation" element={<CheckoutConfirmationPage />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/resend-verification" element={<ResendVerification />} />
                <Route path="/contact-sales" element={<ContactSales />} />
                <Route path="/subscription-plans" element={<SubscriptionPlans />} />
                
                {/* Public Marketing Pages - No auth required */}
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/tools" element={<ToolsPage />} />
                <Route path="/resources" element={<ResourcesPage />} />
                
                {/* Protected Routes - Require Authentication */}
                <Route path="/projects" element={<ProtectedRoute><ProjectsPage /></ProtectedRoute>} />
                <Route path="/project/:projectId" element={<ProtectedRoute><ProjectDetailPage /></ProtectedRoute>} />
                <Route path="/design-templates" element={<ProtectedRoute><DesignTemplatesPage /></ProtectedRoute>} />
                <Route path="/code-references" element={<ProtectedRoute><CodeReferencesPage /></ProtectedRoute>} />
                <Route path="/custom-calculations" element={<ProtectedRoute><CustomCalculationsPage /></ProtectedRoute>} />
                <Route path="/loop-load-calculator" element={<ProtectedRoute><LoopLoadCalculatorPage /></ProtectedRoute>} />
                <Route path="/battery-calculator" element={<ProtectedRoute><BatteryCalculatorPage /></ProtectedRoute>} />
                <Route path="/device-database" element={<ProtectedRoute><DeviceDatabasePage /></ProtectedRoute>} />
                <Route path="/email-preferences" element={<ProtectedRoute><EmailPreferences /></ProtectedRoute>} />
                
                {/* 404 Catch-all */}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
              </Router>
            </ProjectProvider>
          </SubscriptionProvider>
        </EntitlementProvider>
      </AuthProvider>
    </HelmetProvider>
  )
}

export default App
